import styled from 'styled-components';
import { Link } from 'react-scroll';

export const Container = styled.div`
  padding: 18px 28px;

  p {
    text-align: center;
    color: #9d9fa2;
  }
`;

export const TextInput = styled.input`
  background: #f1f1f1;
  color: #000
  font-weight: 600;
  font-size: .9em;
  border: none;
  padding: 15px 10px;
  width: 100%;
  border-radius: 2px;
  margin-bottom: 6px;
  &::placeholder {
    color: #000;
  }
`;

export const GetStartedBtn = styled(Link)`
  display: block;
  text-align: center;
  text-decoration: none;
  width: 100%;
  border: none;
  border-radius: 2px;
  background-color: #f36421;
  color: #fff;
  font-size: 0.9em;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 16px;
  line-height: 3.2;
`;
